import { z } from "zod";
import { buildFromAddress } from "../utils/build-email-address";
import { defineEmailNotificationHandler } from "./types";

const InterviewInviteSchema = z.object({
  conversationId: z.string(),
  interviewId: z.string(),
  organizationName: z.string(),
  title: z.string(),
  date: z.string(),
});

export const interviewInviteHandler = defineEmailNotificationHandler({
  type: "interview.invite",
  icon: "interview",
  title() {
    return "Interview invite";
  },
  description(metadata) {
    const title =
      typeof metadata.title === "string" && metadata.title.trim()
        ? metadata.title
        : undefined;
    return title
      ? `You were invited to ${title}.`
      : "You were invited to an interview.";
  },
  schema: InterviewInviteSchema,
  buildNotificationPayload(data, _ctx) {
    return {
      metadata: {
        conversationId: data.conversationId,
        interviewId: data.interviewId,
        organizationName: data.organizationName,
        title: data.title,
        date: data.date,
      },
      links: {
        href: `/conversations/${data.conversationId}`,
        label: "View invite",
      },
    };
  },
  buildEmailPayload(data, recipient, { baseUrl }) {
    return {
      id: `interview-invite:${data.interviewId}:${recipient.userId}`,
      name: "email/interview.invite",
      data: {
        to: recipient.email ?? "",
        from: buildFromAddress(),
        recipientName: recipient.name ?? "there",
        organizationName: data.organizationName,
        interviewTitle: data.title,
        conversationUrl: `${baseUrl}/conversations/${data.conversationId}`,
        interviewDate: data.date,
      },
    };
  },
});
